<template>
    <div class="my-resources-home">
        <div class="hd">
            <div class="category-items">
                <div
                    class="category-item"
                    v-for="item in category"
                    :class="{ active: item.value === listParams.consumer.consumerule }"
                    @click="handleCategory(item)"
                    :key="item.value"
                >
                    {{ item.name }}
                </div>
            </div>
            <div>
                <el-input
                    size="small"
                    v-model="listParams.searchtext"
                    placeholder="请输入关键字"
                    @keyup.enter.native="refreshList()"
                >
                    <i class="el-icon-search" slot="prefix"> </i>
                </el-input>
                <span @click="showScreen = !showScreen">
                    {{ showScreen ? '收起筛选' : '展开筛选' }}
                    <i class="el-icon-arrow-up" :class="{ 'el-icon-arrow-down': !showScreen }"> </i>
                </span>
            </div>
        </div>
        <screen-cells v-show="showScreen" @change="handleScreen"></screen-cells>
        <div class="list-view">
            <div class="list-wrap" v-show="listData.total">
                <material-list
                    ref="list"
                    :show-item-collect="listParams.consumer.consumerule === 'collected'"
                    @listItemClick="listItemClick"
                    @setListItemCollect="setListItemCollect"
                    :data="listData.list"
                ></material-list>
                <div
                    class="loading"
                    :class="{
                        animate: listData.list.length < listData.total
                    }"
                    v-show="loading"
                >
                    <span>
                        {{ loadingText }}
                    </span>
                </div>
            </div>
            <div v-show="!listData.total && listData.isLoad" class="none-data">
                暂无数据
            </div>
        </div>
    </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex';
import ScreenCells from '@/views/material-market/components/screen-cells.vue';
import MaterialList from '@/views/material-market/components//material-list.vue';

export default {
    name: 'MyResourcesHome',
    components: {
        ScreenCells,
        MaterialList
    },
    data() {
        return {
            category: [
                {
                    name: '已购素材',
                    value: 'payed'
                },
                {
                    name: '下载过的素材',
                    value: 'downloaded'
                },
                {
                    name: '我的收藏',
                    value: 'collected'
                }
            ],
            listParams: {
                typecode: '', // 类别  热门推荐hot 其他类型给对应代码项或者guid
                searchtext: '', // 关键词
                pagesize_lowerlimit: '', // 素材页数下限
                pagesize_upperlimit: '', // 素材页数上限
                shopguid: '', // 素材所属店铺
                consumer: {
                    userguid: '',
                    consumerule: 'payed'
                }, // 素材消费者
                sortingrule: '', // 排序规则
                pageindex: 0,
                pagesize: 12
            },
            listData: {
                list: [],
                total: 0,
                isLoad: false
            },
            screenData: [],
            showScreen: false,
            loading: false
        };
    },
    computed: {
        ...mapGetters(['userInfo']),
        loadingText() {
            return this.listData.list.length < this.listData.total ? '正在加载' : '没有更多数据了';
        }
    },
    created() {
        this.listParams.consumer.consumerule = this.$route.query.consumerule || 'payed';
        this.listParams.consumer.userguid = this.userInfo.userguid;
    },
    mounted() {
        // 添加滚动事件监听
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        // 组件销毁时移除滚动事件监听
        window.removeEventListener('scroll', this.handleScroll);
    },
    methods: {
        ...mapActions(['openMaterialDetailDialog']),
        handleCategory(data) {
            this.listParams.consumer.consumerule = data.value;
            this.refreshList();
        },
        refreshList() {
            this.listParams.pageindex = 0;
            this.listData = {
                list: [],
                total: 0
            };
            this.getList();
        },
        getList() {
            this.loading = true;
            this.$Api.getApplicationCenterList(this.listParams).then((data) => {
                this.loading = false;
                this.listData.list = this.listData.list.concat(data.materiallist);
                this.listData.total = data.pageinfo.totalnumcount;
                this.listData.isLoad = true;
                this.$nextTick(() => {
                    let listHeight = this.$refs.list.$el.offsetHeight;
                    let clientHeight = document.documentElement.clientHeight;
                    if (listHeight < clientHeight && this.listData.list.length < this.listData.total) {
                        this.listParams.pageindex++;
                        this.getList();
                    }
                });
            });
        },
        handleScreen(data) {
            this.listParams = {
                ...this.listParams,
                ...data
            };
            this.refreshList();
        },
        // 处理滚动事件
        handleScroll() {
            // 获取页面滚动位置
            const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
            const clientHeight = document.documentElement.clientHeight;
            const scrollHeight = document.documentElement.scrollHeight;

            // 判断是否滚动到底部（距离底部20px时触发）
            if (scrollHeight - scrollTop - clientHeight <= 32) {
                // 如果还有更多数据
                if (!this.loading && this.listData.list.length < this.listData.total) {
                    this.listParams.pageindex++;
                    this.getList();
                } else {
                    this.loading = true;
                }
            }
        },
        // 列表点击
        listItemClick(data) {
            this.openMaterialDetailDialog(data.materialguid);
        },
        setListItemCollect(data) {
            this.$confirm('确认取消收藏吗?', '操作确认', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                callback: (action) => {
                    if (action === 'confirm') {
                        this.$Api
                            .setMaterialCollected({
                                materialguid: data.materialguid,
                                userguid: this.userInfo.userguid,
                                isadd: false
                            })
                            .then((data) => {
                                this.$message({
                                    type: data.state,
                                    message: data.message
                                });
                                data.state === 'success' && this.refreshList();
                            });
                    }
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
@import './style/my-resources-home.scss';
</style>
